import { HttpClient } from "@angular/common/http";
import { API_URL } from "@app/shared/constants/settings.constant";
import { Observable } from "rxjs";
import { DictionaryItem } from "@app/shared/services/dictionary/dictionary-item.model";

export enum DictionaryEnum {
  "PASSENGER_OR_OFFROAD_VEHICLE" = "Osobowe/terenowe",
  "DELIVERY_VEHICLE" = "Dostawcze/osobowo-dostawcze",
  "OWNER" = "Właściciel",
  "FIRST_CO_OWNER" = "Pierwszy współwłaściciel",
  "CO_OWNER" = "Współwłaściciel",
  "SECOND_CO_OWNER" = "Drugi współwłaściciel",
  "MALE" = "Mężczyzna",
  "FEMALE" = "Kobieta"
}

export abstract class DictionaryService {
  private httpClient: HttpClient;

  protected constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  convertEnumToDictionaryItems(_enum: object): DictionaryItem[] {
    return Object.keys(_enum).map(
      (enumKey) =>
        new DictionaryItem(enumKey, DictionaryEnum[enumKey], null, null)
    );
  }

  protected getDictionary<T>(url: string, params: any = {}): Observable<T[]> {
    return this.dictionary<T[]>(url, params);
  }

  protected getDictionaryItem<T>(url: string, params: any = {}): Observable<T> {
    return this.dictionary<T>(url, params);
  }

  private dictionary<T>(url: string, params: any): Observable<T> {
    return this.httpClient.get<T>(`${this.getBaseUrl()}${url}`, { params });
  }

  private getBaseUrl(): string {
    return `${API_URL}/dictionary`;
  }
}
